import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.daily.receipt.preview');
import { Input, OnChanges } from '@angular/core';

@Component({
    selector: 'wiz-component-daily-receipt-preview',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.daily.receipt.preview/view.scss */
:host {
  display: block;
  width: min(390px, 100%);
}

.daily-receipt-paper,
.daily-receipt-paper * {
  box-sizing: border-box;
}

.daily-receipt-paper {
  --receipt-accent: #4f463c;
  --receipt-ink: #28231e;
  --receipt-muted: #71685d;
  --receipt-soft: rgba(79, 70, 60, 0.08);
  --receipt-line: rgba(47, 42, 37, 0.34);
  --receipt-paper: #fffdf7;
  --receipt-shadow: rgba(50, 42, 31, 0.16);
  position: relative;
  width: 100%;
  min-width: 0;
  border: 1px solid rgba(130, 114, 92, 0.22);
  padding: 24px 22px;
  overflow: hidden;
  color: var(--receipt-ink);
  background: radial-gradient(circle at 12px 10px, rgba(80, 68, 48, 0.055) 0 1px, transparent 1.8px), radial-gradient(circle at 27px 31px, rgba(80, 68, 48, 0.038) 0 1px, transparent 1.7px), linear-gradient(90deg, rgba(255, 255, 255, 0.42), transparent 12%, transparent 88%, rgba(96, 82, 62, 0.05)), linear-gradient(180deg, #ffffff 0%, var(--receipt-paper) 62%, #fbf5ea 100%);
  background-size: 20px 20px, 24px 24px, auto, auto;
  box-shadow: 0 24px 46px var(--receipt-shadow);
  font-family: var(--ownit-font-typewriter, OwnitTypewriter, OwnitNanumGothic, "Courier New", monospace);
}

.daily-receipt-paper.is-empty {
  --receipt-accent: #7b6a57;
  --receipt-muted: #82766a;
}

.daily-receipt-cut {
  height: 12px;
  margin: -24px -22px 16px;
  border-bottom: 1px dashed var(--receipt-line);
  background: repeating-linear-gradient(90deg, rgba(47, 42, 37, 0.16) 0 1px, transparent 1px 8px), linear-gradient(180deg, rgba(255, 255, 255, 0.6), transparent);
}

.daily-receipt-cut.bottom {
  margin: 18px -22px -24px;
  border-top: 1px dashed var(--receipt-line);
  border-bottom: 0;
  background: repeating-linear-gradient(90deg, rgba(47, 42, 37, 0.14) 0 1px, transparent 1px 8px), linear-gradient(0deg, rgba(255, 255, 255, 0.5), transparent);
}

.daily-receipt-header {
  display: grid;
  justify-items: center;
  gap: 5px;
  padding-bottom: 15px;
  text-align: center;
}

.daily-receipt-brand {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--receipt-accent);
  font-family: var(--ownit-font-nanum-gothic, OwnitNanumGothic, "Malgun Gothic", sans-serif);
  font-size: 12px;
  font-weight: 800;
}

.daily-receipt-brand-mark {
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border: 1px solid rgba(79, 70, 60, 0.24);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.54);
  font-family: var(--ownit-font-typewriter, OwnitTypewriter, "Courier New", monospace);
}

.daily-receipt-kicker,
.daily-receipt-header p,
.daily-receipt-footer p,
.daily-receipt-footer span {
  margin: 0;
  color: var(--receipt-muted);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
}

.daily-receipt-header h3 {
  margin: 1px 0 0;
  color: var(--receipt-ink);
  font-family: var(--ownit-font-nanum-gothic, OwnitNanumGothic, "Malgun Gothic", sans-serif);
  font-size: 21px;
  font-weight: 800;
  line-height: 1.24;
}

.daily-receipt-meta,
.daily-receipt-mood,
.daily-receipt-summary,
.daily-receipt-empty-note,
.daily-receipt-section {
  border-top: 1px dashed var(--receipt-line);
  padding: 13px 0;
}

.daily-receipt-meta-row,
.daily-receipt-section-title,
.daily-receipt-line,
.daily-receipt-total-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 12px;
  min-width: 0;
}

.daily-receipt-meta-row + .daily-receipt-meta-row {
  margin-top: 7px;
}

.daily-receipt-meta-row span,
.daily-receipt-section-title span,
.daily-receipt-total-row span,
.daily-receipt-line span {
  min-width: 0;
  overflow: hidden;
  color: var(--receipt-muted);
  font-size: 11px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.daily-receipt-meta-row strong,
.daily-receipt-section-title strong,
.daily-receipt-total-row strong {
  color: var(--receipt-ink);
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.daily-receipt-mood {
  display: flex;
  align-items: center;
  gap: 13px;
}

.daily-receipt-emoji {
  display: grid;
  place-items: center;
  flex: 0 0 54px;
  width: 54px;
  height: 54px;
  border: 1px solid rgba(130, 114, 92, 0.28);
  border-radius: 999px;
  background: radial-gradient(circle at 34% 28%, rgba(255, 255, 255, 0.94), transparent 38%), rgba(248, 239, 226, 0.84);
  font-family: "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif;
  font-size: 29px;
  line-height: 1;
}

.daily-receipt-mood div {
  min-width: 0;
}

.daily-receipt-mood span,
.daily-receipt-mood strong,
.daily-receipt-mood small {
  display: block;
}

.daily-receipt-mood span {
  color: var(--receipt-muted);
  font-size: 11px;
  font-weight: 600;
}

.daily-receipt-mood strong {
  margin-top: 4px;
  color: var(--receipt-ink);
  font-family: var(--ownit-font-nanum-gothic, OwnitNanumGothic, "Malgun Gothic", sans-serif);
  font-size: 17px;
  font-weight: 800;
}

.daily-receipt-mood small {
  margin-top: 4px;
  color: var(--receipt-muted);
  font-size: 10px;
  font-weight: 700;
}

.daily-receipt-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.daily-receipt-summary div {
  min-width: 0;
  border: 1px solid rgba(47, 42, 37, 0.1);
  padding: 8px 5px;
  background: rgba(255, 253, 247, 0.62);
  text-align: center;
}

.daily-receipt-summary span,
.daily-receipt-summary strong {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.daily-receipt-summary span {
  color: var(--receipt-muted);
  font-size: 10px;
  font-weight: 700;
}

.daily-receipt-summary strong {
  margin-top: 4px;
  color: var(--receipt-ink);
  font-size: 12px;
  font-weight: 800;
}

.daily-receipt-empty-note {
  display: grid;
  justify-items: center;
  gap: 5px;
  border-top-style: solid;
  border-bottom: 1px dashed var(--receipt-line);
  padding: 18px 10px;
  color: var(--receipt-muted);
  text-align: center;
}

.daily-receipt-empty-note span {
  border: 1px solid rgba(47, 42, 37, 0.14);
  padding: 4px 8px;
  color: var(--receipt-accent);
  background: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  font-weight: 800;
}

.daily-receipt-empty-note strong {
  color: var(--receipt-ink);
  font-family: var(--ownit-font-nanum-gothic, OwnitNanumGothic, "Malgun Gothic", sans-serif);
  font-size: 14px;
  font-weight: 800;
}

.daily-receipt-empty-note p {
  max-width: 270px;
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.55;
}

.daily-receipt-section {
  padding-bottom: 9px;
}

.daily-receipt-section-title {
  margin-bottom: 9px;
}

.daily-receipt-mini-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin: 1px 0 8px;
}

.daily-receipt-mini-stats span {
  min-width: 0;
  border: 1px solid rgba(47, 42, 37, 0.1);
  padding: 5px 6px;
  overflow: hidden;
  color: var(--receipt-muted);
  background: rgba(255, 253, 247, 0.64);
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.daily-receipt-line {
  border-left: 3px solid rgba(130, 114, 92, 0.3);
  border-top: 1px solid rgba(47, 42, 37, 0.1);
  padding: 7px 0 7px 9px;
}

.daily-receipt-line:first-of-type {
  border-top: 0;
}

.daily-receipt-line div {
  min-width: 0;
}

.daily-receipt-line strong {
  display: block;
  min-width: 0;
  overflow-wrap: anywhere;
  color: var(--receipt-ink);
  font-family: var(--ownit-font-nanum-gothic, OwnitNanumGothic, "Malgun Gothic", sans-serif);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.38;
}

.daily-receipt-line em {
  color: var(--receipt-accent);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  text-align: right;
  white-space: nowrap;
}

.daily-receipt-line.open em {
  color: #a45d4e;
}

.daily-receipt-empty-line {
  border: 1px dashed rgba(47, 42, 37, 0.18);
  padding: 9px;
  color: var(--receipt-muted);
  background: rgba(255, 255, 255, 0.34);
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}

.daily-receipt-note-section p {
  margin: 8px 0 0;
  color: var(--receipt-ink);
  font-family: var(--ownit-font-nanum-gothic, OwnitNanumGothic, "Malgun Gothic", sans-serif);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.62;
  white-space: pre-wrap;
}

.daily-receipt-total-section {
  padding-bottom: 0;
}

.daily-receipt-total-row + .daily-receipt-total-row {
  margin-top: 8px;
}

.daily-receipt-total-row.grand-total {
  border-top: 2px solid var(--receipt-ink);
  padding-top: 10px;
}

.daily-receipt-total-row.grand-total strong {
  font-size: 16px;
}

.daily-receipt-footer {
  display: grid;
  justify-items: center;
  gap: 4px;
  border-top: 1px dashed var(--receipt-line);
  padding-top: 17px;
  text-align: center;
}

.daily-receipt-barcode {
  width: 128px;
  height: 30px;
  margin-bottom: 5px;
  background: repeating-linear-gradient(90deg, var(--receipt-ink) 0 2px, transparent 2px 5px, var(--receipt-ink) 5px 6px, transparent 6px 10px);
  opacity: 0.68;
}

@media (max-width: 420px) {
  :host {
    width: 100%;
  }
  .daily-receipt-paper {
    padding: 21px 17px;
  }
  .daily-receipt-cut {
    margin: -21px -17px 14px;
  }
  .daily-receipt-cut.bottom {
    margin: 16px -17px -21px;
  }
  .daily-receipt-header h3 {
    font-size: 19px;
  }
  .daily-receipt-summary {
    gap: 5px;
  }
}`],
})
export class ComponentDailyReceiptPreviewComponent implements OnChanges {
    @Input() receipt: any = null;
    public sections: any[] = [];

    public ngOnChanges() {
        this.sections = Array.isArray(this.receipt?.sections) ? this.receipt.sections : [];
    }

    public trackBySection(index: number, section: any) {
        return section?.id || index;
    }

    public trackByItem(index: number, item: any) {
        return item?.id || index;
    }

    public trackByMetric(index: number, metric: any) {
        return metric?.id || index;
    }
}

export default ComponentDailyReceiptPreviewComponent;